import { 
  Component,
  ViewEncapsulation,
  AfterViewInit,
  OnDestroy,
  HostListener,
  OnInit,
  ElementRef,
  ViewChild
} from '@angular/core';
import { UserDetailsService } from ".././services/user-details.service";
import { BonusService } from "../app-myaccount/bonuses/services/bonus.service";
import { EmitterService } from "../services/emitter.service";
import { PnpZimplerService } from '../services/pnp-zimpler.service';
import { myAccountTabs, myAccountTabsMobile, userJurisdictions } from "../shared/utility/config";
import { takeUntil, share } from "rxjs/operators";
import { forkJoin, Subject } from "rxjs";
import { environment } from "../../environments/environment";
import { Utility } from "../shared/utility/utility";
import { GameWindowService } from '../services/gameWindow.services';
import { PromotionsService } from '../services/promotions.service';
import { ChangeDetectorRef } from '@angular/core';
import {
  Router,
  ActivatedRoute,
  NavigationEnd,
  NavigationStart,
} from "@angular/router";

import * as $ from "jquery";
window["$"] = window["jQuery"] = $;
import * as _ from "underscore";
import PerfectScrollbar from 'perfect-scrollbar';
import { AjaxService } from '../services/ajax.service';
import { Utilities } from '../services/utilities.services';

@Component({
  selector: 'app-nav-panel',
  templateUrl: './app-nav-panel.component.html',
  styleUrls: ['./app-nav-panel.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppNavPanelComponent implements AfterViewInit, OnDestroy, OnInit {
  siteUrlPath: string = environment.siteUrl;
  webisteCode = environment.website_code;
  mediaUrlPath = environment.mediaPath;
  langCode;

  destroy$: Subject<boolean> = new Subject<boolean>();

  windowType;
  websiteName = environment.website_name;
  websiteLogoExtension = environment.website_logo_extension;
  isUserLoggedIn;
  isCountryAllowed: number = 0;
  isToShowOverlay:boolean = false;
  isToShowNavPanel:boolean = false;
  isToShowMyAccountPanel:boolean = false;
  currentView;
  myAccountTabs;
  myAccountTabsMobile;
  eligibleBonusLength;
  isZimplerProfile;
  totalPendingWithdrawalsAvailable;
  lobbyDetails:any;
  gameGroupDetails:any;
  specialPromotions;
  isZendeskEnabled = environment.zendeskServiceConfig["isEnabled"];

  bonusApis;
  isBonusLoading = true;
  @ViewChild('myAccountSelect') myAccountSelect:ElementRef;
  @HostListener("window:resize") onResize() {
    this.deviceType();
    this.alignMyAccountPanel();
    if(window.location.href.includes('/myaccount?openModal=preferences') && document.body.clientWidth <= 992){
      let langCode = localStorage.getItem('langCode') ? localStorage.getItem('langCode') : 'en';
      this.router.navigate(['/'+langCode]);
    }
  }

  @HostListener("document:click", ["$event"]) onClick(event) {
    if (event.target.classList.contains("overlay") && !this.utils.getIsSideMenuOpened()) {
      document.body.classList.remove('hiddenOverflow');
    }
  }

  constructor(
    public userDetailsService: UserDetailsService,
    private bonusService: BonusService,
    private emitterService: EmitterService,
    private pnpService: PnpZimplerService,
    private utils: Utility,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private gameWindowService:GameWindowService,
    private promotionsService: PromotionsService,
    private cdref: ChangeDetectorRef,
    private ajaxService:AjaxService,
    private utilities: Utilities
  ) {
    this.myAccountTabs = myAccountTabs;
    this.myAccountTabsMobile = myAccountTabsMobile;
    this.emitterService.showPreferenceFromNotificationBanner$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.isToShowNavPanel= true;
      this.isToShowMyAccountPanel= true;
      this.displayAccountMenu('PREFERENCE');
      this.myAccountSelect.nativeElement.click();
    });
    this.langCode = localStorage.getItem('langCode');
    this.emitterService.langCodeSource$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
        this.langCode = data;
        // this.utils.getTime();
    });

    this.emitterService.getLangBasedResponse$.pipe(takeUntil(this.destroy$)).subscribe(langCode => {
      this.getAllPromotionData(true);
      this.getGameDetails(true);
    });

    this.isUserLoggedIn = this.utils.isUserLoggedIn();
    this.emitterService.updateLoginStatus$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.isUserLoggedIn = data;
      setTimeout(()=>{
        this.toggleDropdown()
      },10)
      this.checkPendingwithDrawls();
    });

    this.emitterService.isCountryAllowed$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.isCountryAllowed = data;
    });

    this.emitterService.isZimplerForm$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.isZimplerProfile = data;
    })
    this.emitterService.openMyAccountPage$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.openMyAccountPage();
    })
    this.bonusService.eligibleBonusRefresh$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      if(data) this.getBonusesData();
    });
    this.bonusApis = forkJoin([this.bonusService.getEligibleBonus(),this.ajaxService.getActiveBonus()]).pipe(share());

    this.emitterService.toggleNavPanel$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
    if(data.isBack){
          data = true;
    }
     if(this.utils.isSideMenuOpened && data || this.utils.isMobile()){
      this.getBonusesData();
    }

      if(data){
        $("body").addClass("nav-open");
        if(this.isUserLoggedIn) {
          this.bonusService.broadRefreshEligibleBonus(true);
        }
      }else{
        $("body").removeClass("nav-open");
      }

      this.isToShowNavPanel = data;
      this.isToShowMyAccountPanel = false;
      // $(".dropdown-section--btn").parent().find("ul").removeClass("expanded");
      // $(".dropdown-section--btn").eq(0).parent().find("ul").addClass("expanded");
      // $(".dropdown-section--btn").children('i').removeClass('rotate');
      // $(".dropdown-section--btn").eq(0).children('i').addClass('rotate');
      this.toggleDropdown();
      // if(data){
      //   this.bonusService.activeFreeSpinsData = [];
      //   this.bonusService.eligibleBonusData = [];
      //   this.getBonusesData();
      // }
    });

    this.userDetailsService.userBalanceUpdated$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.checkPendingwithDrawls();
    });

    this.emitterService.upDatePendingWithdrawlCount$.pipe(takeUntil(this.destroy$)).subscribe(data=>{
      this.checkPendingwithDrawls();
    });

    this.router.events.pipe(takeUntil(this.destroy$)).subscribe(event=>{
      this.getBonusesData();
      if(event instanceof NavigationStart){
        this.closeNavPanel();
      }
      else if (event instanceof NavigationEnd) {
        let isPreference = Boolean(this.activatedRoute.snapshot.queryParams["preferences"]);
        let showAccount = Boolean(this.activatedRoute.snapshot.queryParams["showAccount"]);
        // let sh = Boolean(this.activatedRoute.snapshot.queryParams["showAccount"]);
        if (isPreference) {
          this.currentView = 'PREFERENCE';
          this.isToShowMyAccountPanel = true;
        } else if (showAccount) {
          this.currentView = 'MYACCOUNT';
          this.isToShowMyAccountPanel = true;
        } else {
          
        }

        if(event instanceof NavigationEnd && (event.url.includes('casino') || event.url === "/" + this.langCode)) {
          this.getGameDetails();
        }

      }
    });
  }

  ngOnInit(): void {
    this.getBonusesData();
  }
  closeSearch(){
    this.emitterService.broadCastShowSearchBar(false);
  }
  getWithdrawalTabs() {
    return myAccountTabsMobile.find((tab) => tab.id === "withdrawls");
  }

  checkPendingwithDrawls() {
    this.totalPendingWithdrawalsAvailable = 0;
    if(this.isUserLoggedIn) {
      let pendingWithdrawalObject = {
        cashoutVerifiedtxnRequired: true
      }
      this.pnpService.getPendingCashOuts(pendingWithdrawalObject).then(data=>{
        let withdrawlTab = this.getWithdrawalTabs();
        if(data && data.length > 0) {
          this.totalPendingWithdrawalsAvailable = data.length;
        } else  {
          this.totalPendingWithdrawalsAvailable = 0;
        }
      });
    }
  }

  deviceType() {
    const ww = document.body.clientWidth;
    if (ww <= 992) {
      this.windowType = "mobile";
    } else {
      this.windowType = "desktop";
    }
  }


  ngAfterViewInit() {
    this.deviceType();
    this.toggleDropdown();
    this.cdref.detectChanges();
    // const ps = new PerfectScrollbar('.navPanel--content');
  }

  toggleDropdown(){
    $(".dropdown-section--btn").unbind("click").bind("click", function(){
      $(".dropdown-section--btn").children('i').removeClass('rotate');
      if($(this).parent().find("ul").hasClass("expanded")){
        $(this).parent().find("ul").removeClass("expanded");
        $(this).children('i').removeClass('rotate');
      } else {
        $(".dropdown-section--btn").parent().find("ul").removeClass("expanded");
        $(".dropdown-section--btn").children('i').removeClass('rotate');
        $(this).parent().find("ul").addClass("expanded");
        $(this).children('i').addClass('rotate');
      }
    });
  }

  /* Setting Game Details */ 
  getGameDetails(isForce=false) {
    this.lobbyDetails = this.gameWindowService.lobbyDetails;

    const lobbyAndGameGroupFetchArray = [];
    if(!this.lobbyDetails || isForce){
      this.lobbyDetails = [];
      if(isForce){
        this.gameWindowService.lobbyDetails = undefined;
      }
      lobbyAndGameGroupFetchArray.push(this.gameWindowService.getLobbies(isForce))
    }
    
    if(lobbyAndGameGroupFetchArray.length > 0){
      forkJoin(lobbyAndGameGroupFetchArray).pipe(takeUntil(this.destroy$)).subscribe(lobbyGameGroupDetails =>{
        this.lobbyDetails = this.gameWindowService.lobbyDetails;
      })
    }
  }

  getAllPromotionData(forceData) {
    Promise.resolve(this.promotionsService.getPromotionsData(forceData)).then(promotionsResp => {
      this.specialPromotions = promotionsResp;
      this.specialPromotions = this.specialPromotions.filter(promotionIndexVal => ((promotionIndexVal["name"].toLowerCase()).indexOf("-menu") != -1));
    });
  }
  getBonusesData(){
    if(this.utils.isUserLoggedIn() && (!this.bonusService.activeFreeSpinsData?.length || !this.bonusService.activeBonusList?.length)){
      this.isBonusLoading = true;
      this.bonusService.activeFreeSpinsData = [];
      this.bonusService.eligibleBonusData = [];
      forkJoin(this.bonusApis)
      .subscribe((bonusData:any) => {
        let depositBonusObj = bonusData[0][0];
        let freeSpinsObj = bonusData[0][1];
        if(bonusData?.length){
          let freeSpinsData = [];
          freeSpinsData = freeSpinsObj.filter(bonus=>{
                 if(bonus.isFreeSpinBonus && !bonus.isFreeSpinsCompleted){
                    return bonus;
                 }
          })
          if(depositBonusObj?.eligibleBonusList?.length){
            this.bonusService.eligibleBonusList = depositBonusObj.eligibleBonusList.filter((eligibleBonus)=> eligibleBonus.criteriaType=="DEPOSIT")
          }else{
            this.bonusService.eligibleBonusList = [];
          }
          
          this.bonusService.activeFreeSpinsData = freeSpinsData?.length ? freeSpinsData : [];
          this.bonusService.activeBonusList = (depositBonusObj?.eligibleBonusList?.length) ? bonusData[0][1] : [];
          let count = 0;
          this.bonusService?.eligibleBonusList.map((bonus)=>{
            if(bonus.gameIds.length === 0){
              count+=1
            }else{
              count+=bonus.gameIds.length
            }
          })
          this.eligibleBonusLength = (freeSpinsData?.length ? freeSpinsData?.length : 0 ) + count
          this.emitterService.broadCastUpdateBonusDetails(true);
        }else{
          this.bonusService.activeBonusList = [];
          this.bonusService.activeFreeSpinsData = [];
          this.eligibleBonusLength = 0
          this.emitterService.broadCastUpdateBonusDetails(true);
        }
        this.isBonusLoading = false;
      })
    }
  }
  

  hideZimplerUpdate(){
    if(this.isZimplerProfile){
      this.emitterService.broadCastIsZimplerForm(false);
    }
  }
  openMyAccountPage(){
    this.isToShowNavPanel = true;      
    this.myAccountDesktopNavigation("profileSettingsComp.myAccount", "/myaccount")    
  }

  myAccountDesktopNavigation(name, path) {
    if(!this.isToShowMyAccountPanel) {
      this.emitterService.broadcastRouteChange(false);
      // this.bonusService.broadRefreshEligibleBonus(true); //making eligible bonus api call when opening myaccount
      //document.body.classList.add('hiddenOverflow');
      this.hideZimplerUpdate();
      this.isToShowMyAccountPanel = true;
      this.alignMyAccountPanel();
      // this.closeNavPanel();
    }

    switch (name) {
      case 'profileSettingsComp.cashier':
        this.currentView = 'CASHIER';
        return;

      case 'profileSettingsComp.withdrawals':
        this.closeNavPanel();
        this.emitterService.broadcastModalState({name:"pendingwithdrawl",state:"open"});
        this.currentView = '';
        return;

      case 'profileSettingsComp.bonuses':
        this.currentView = 'BONUSES';
        return;

      case 'profileSettingsComp.myAccount':
        this.currentView = 'MYACCOUNT';
        return;

      case 'profileSettingsComp.myTransactions':
        this.currentView = 'TRANSACTIONS';
        return;

      case 'profileSettingsComp.gameHistory':
        this.currentView = 'BETHISTORY';
        return;

    }
    this.router.navigate([this.langCode + path]);
  }

  myAccountMobileNavigation(myaccountTab) { 
    this.closeSearch();
    this.emitterService.broadCastToggleNavPanel(false);

    if(this.router.url != "myaccount") {
      this.router.navigate([this.langCode + '/myaccount']);
    }

    setTimeout(() => {
      this.emitterService.broadCastMyAccountActiveTabData(myaccountTab);
    });

  }

  toggleZDChat() {
    this.utilities.initChat();
  }

  displayAccountMenu(view?) { 
    if (view && typeof view === 'string') {
      this.currentView = view;
    }else {
      this.currentView = "MYACCOUNT";
    }
  }

  alignMyAccountPanel() {
    setTimeout(() => {
      let navPanelEleRef: HTMLElement = document.querySelector(".header_container");
      let myAccountPanelEleRef: HTMLElement = document.querySelector(".myAccountPanel");
      if (navPanelEleRef !== null && myAccountPanelEleRef !== null) {

        if (this.isToShowNavPanel) {
         // $("body").addClass("hiddenOverflow");
          myAccountPanelEleRef.style.display = "block";
        } else {
          //$("body").removeClass("hiddenOverflow");
          myAccountPanelEleRef.style.display = "none";
        }
      }
    });
  }

  register(event) {
    event.preventDefault();
    this.closeNavPanel();
    this.emitterService.broadCastXSaleRegistration(true)
  }

  moveToTrustlyPay(){
    this.closeNavPanel();
    this.emitterService.broadCastToggleNavPanel(false);
    if(this.userDetailsService.checkZimplerDepositOpen()) {
      this.pnpService.openZimplerDeposit()
    }
  }

  deposit() {
    this.closeNavPanel();
    if((this.userDetailsService.checkZimplerDepositOpen())) {
      this.pnpService.openZimplerDeposit()
    } else if(!this.userDetailsService.checkIsPNPUser()){
      this.emitterService.broadcastModalState({ name: "paymentModal", state: "open", cashierType: "deposit" });
    }
  }

  closeNavPanel() {
    this.closeSearch();
    this.emitterService.broadCastSideMenuStatus(false);
    if(!location.href.includes('page=step2')){
      this.emitterService.broadCastToggleNavPanel(false);
      this.utils.setIsSideMenuOpened(false);
    }
   this.utils.disablescrollOnRegistrationPageOpend();
  }

  doLogout() {
    this.userDetailsService.doLogout();
  }
  checkUserLoginStatus(){
    let isUserEstoniaJuridiction = this.userDetailsService?.userProfileDetails?.jurisdiction == userJurisdictions[0] ? true : false;
    return this.windowType == "mobile" && isUserEstoniaJuridiction && this.utils.isUserLoggedIn()
  }
  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

}
